var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTokenWeth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 22C6.6 22 3 20.875 3 19.4876C3.04 18.1126 6.6 16.9876 11.04 17.0001C15.44 17.0126 19 18.1251 19 19.5251C18.96 20.8875 15.4 22 11 22Z",
    fill: "url(#paint0_linear_3246_17988)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 20C5.27499 20 0.999986 15.7251 0.999986 10.4527C1.04749 5.22778 5.27499 0.952867 10.5475 1.00037C15.7725 1.04787 20 5.27528 20 10.5952C19.9525 15.7726 15.725 20 10.5 20Z",
    fill: "url(#paint1_linear_3246_17988)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 12.4536C4.20049 17.6158 8.3864 21.8 13.5 21.8C18.6145 21.8 22.7529 17.662 22.8 12.5944C22.7996 7.3844 18.6604 3.24689 13.5457 3.20038L4.2 12.4536ZM4.2 12.4536C4.247 7.33681 8.38669 3.15392 13.5457 3.20038L4.2 12.4536Z",
    fill: "url(#paint2_linear_3246_17988)",
    stroke: "url(#paint3_linear_3246_17988)",
    strokeWidth: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79509 15L7 11H7.75484L8.08696 12.9198L8.27316 14.0315H8.28825L8.50967 12.9198L8.89715 11H9.73251L10.125 12.9198L10.3414 14.0315H10.3565L10.5427 12.9198L10.8799 11H11.6045L10.7893 15H9.9187L9.47586 12.8338L9.30477 11.957H9.28967L9.11354 12.8338L8.6707 15H7.79509Z",
    fill: "url(#paint4_linear_3246_17988)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1362 15V11H14.5265V11.7736H12.9011V12.5931H14.295V13.361H12.9011V14.2264H14.5265V15H12.1362Z",
    fill: "url(#paint5_linear_3246_17988)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6573 11.7736V15H15.8924V11.7736H14.9413V11H17.6084V11.7736H16.6573Z",
    fill: "url(#paint6_linear_3246_17988)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2351 13.361H18.8965V15H18.1316V11H18.8965V12.5931H20.2351V11H21V15H20.2351V13.361Z",
    fill: "url(#paint7_linear_3246_17988)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3246_17988",
    x1: 0.5,
    y1: 20,
    x2: 9,
    y2: 20.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B36EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4876FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3246_17988",
    x1: -4.45251,
    y1: 3.50037,
    x2: 7.04749,
    y2: 12.5004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113637,
    stopColor: "#B36EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4876FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3246_17988",
    x1: 6.5,
    y1: 9.5,
    x2: 13.4998,
    y2: 24.2613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.180113,
    stopColor: "#B36EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4876FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3246_17988",
    x1: 4,
    y1: 2,
    x2: 13.5,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3246_17988",
    x1: 14,
    y1: 11,
    x2: 20.055,
    y2: 14.8357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3246_17988",
    x1: 14,
    y1: 11,
    x2: 20.055,
    y2: 14.8357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3246_17988",
    x1: 14,
    y1: 11,
    x2: 20.055,
    y2: 14.8357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3246_17988",
    x1: 14,
    y1: 11,
    x2: 20.055,
    y2: 14.8357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenWeth);
export default __webpack_public_path__ + "static/media/token-weth.2f2450d6304a4e60a12b4a36da829ba9.svg";
export { ForwardRef as ReactComponent };